import gsap, { Power2 } from 'gsap';
import { Shffl } from '../_app/cuchillo/components/Shffl';
import { Basics, hasSlowConnection, isSmartphone, isTouch } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';
import EventDispatcher from '../_app/cuchillo/core/EventDispatcher';
import { Interaction } from '../_app/cuchillo/core/Interaction';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import ParticlesProjectList from '../components/ParticlesProjectList';
import BGVideo from '../layout/BGVideo';
import Default from './Default';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import ProgressScroller from '../components/ProgressScroller';
import CircleVisor from '../layout/CircleVisor';
import VideoMultiple from '../layout/VideoMultiple';
import WheelControls from '../_app/cuchillo/scroll/WheelControls';
import ProjectsVisor from '../components/ProjectsVisor';
import Header from '../layout/Header';
import Wrap from '../layout/Wrap';
import Preloader from '../layout/Preloader';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Page from '../_app/cuchillo/pages/Page';

const TIME_FRAME = .01;

export default class Home extends Default {
  progressScroller;

//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================

  constructor() {
    super();

    this.projectsVisor = new ProjectsVisor(GetBy.class("widget-home")[0]);
    CircleVisor.reset();
  }

  show__effect(__call) {
    if (this.isFirstTime) {
      Wrap.directShow();
      this.projectsVisor.show(true);
      Preloader.hide(() => {
        Header.showLogo();
        CircleVisor.show();
        this.projectsVisor.progressScroller.start();
        this.afterShow();
      });
    } else {
      Wrap.directShow();
      Header.showLogo();
      this.projectsVisor.show();
      this.afterShow();
    }
  }

  dispose() {
    super.dispose();
  }

  beforeShow() {
    Keyboard.mountPage(this.id);
  }

  afterShow() {
    this._isActive = true;
    Header.showAlpha();
    //this.vm.play();
    Header.showLogo();
    this.projectsVisor.show();
  }

  hide__effect() {
    Header.hideLogo();
    this.projectsVisor.hide(()=> {
      
      Scroll.hide();
      BGVideo.hide();
      Wrap.hide(() => { this.afterHide(); });
    });
  }

  beforeHide() {
    super.beforeHide();
  }

  afterHide() {
    super.afterHide();
  }

  //RESIZE
  resize() {
    this.projectsVisor.resize();
    super.resize();    
  }

  dispose() {
    super.dispose();
     this.projectsVisor.dispose();
  }
   //LOOP
  loop() {
    this.projectsVisor.loop();
    //this.progressScroller.loop();
    /*const velocity = this.progressScroller.speed * .02;

   

    if(Math.abs(velocity) > TIME_FRAME) {
        CircleVisor.speed = -velocity * .035;
        this.vm.changeTime(this.vm.currentTime - velocity);
    } else {
        CircleVisor.speed = TIME_FRAME * .035;
    }*/

    //CircleVisor.speed = this.speed;
    //this.speed = 
   // this.progressScroller.loop();
   // CircleVisor.speed = -this.progressScroller.speed * .0002;
  //  this.max = Math.max(Math.abs(this.progressScroller.speed), this. max);

      
   /* if(this.progressScroller.speed) {
      CircleVisor.progress =
        VideoMultiple.progress = this.progressScroller.progress;
    } else {*/
     // CircleVisor.progress =  this.vm.progress;
    //}
    
    //this.vm.loop();
    
    //this.particlesHome.loop();
  }
}

ControllerPage._addPage("page-home", Home)
